import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line no-unused-vars
import axios from 'axios'
import { EventBus } from './bus.js'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        timezones: ['Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Fort_Nelson', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Kralendijk', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Tortola', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Colombo', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kathmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qostanay', 'Asia/Qyzylorda', 'Asia/Riyadh', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ulaanbaatar', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faroe', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul', 'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye', 'Europe/Zurich', 'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Wake', 'Pacific/Wallis', 'UTC', ''],
        chars_transcription: {
            good_chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789- ',
            chars_substitute: {
                'a': 'A',
                'b': 'B',
                'c': 'C',
                'd': 'D',
                'e': 'E',
                'f': 'F',
                'g': 'G',
                'h': 'H',
                'i': 'I',
                'j': 'J',
                'k': 'K',
                'l': 'L',
                'm': 'M',
                'n': 'N',
                'o': 'O',
                'p': 'P',
                'q': 'Q',
                'r': 'R',
                's': 'S',
                't': 'T',
                'u': 'U',
                'v': 'V',
                'w': 'W',
                'x': 'X',
                'y': 'Y',
                'z': 'Z',
                // russian characters
                'а': 'A',
                'А': 'A',
                'в': 'B',
                'В': 'B',
                'е': 'E',
                'Е': 'E',
                'к': 'K',
                'К': 'K',
                'м': 'M',
                'М': 'M',
                'н': 'H',
                'Н': 'H',
                'о': 'O',
                'О': 'O',
                'р': 'P',
                'Р': 'P',
                'с': 'C',
                'С': 'C',
                'т': 'T',
                'Т': 'T',
                'у': 'Y',
                'У': 'Y',
                'х': 'X',
                'Х': 'X'
            }
        },
        current_system_timezone: '',
        current_browser_timezone: '',
        system_datetime: '',

        system_params: {
            journal_data_storage_period: '',
            service_connection_url: '',
            library_license_key: '',
            serial: '',
            name: '',
            network_role: '',
            network_connection_url: '',
            backend_network_ip: '127.0.0.1',

            processing_method: '',
            passage_detection_method: '',
            re_recognition_delay: '',
            min_plate_width: '',
            max_plate_width: '',

            memory_check_schedule: '',
            memory_check_schedule_weekdays: '',
            memory_check_schedule_daily_start_time: '',
            memory_check_schedule_daily_end_time: ''
        },
            
        system_connection_state: {
            service_is_connected: false,
            relays_are_connected: false,
        },
        menu_items: [
          {
              link: 'recognition_journal',
              name: 'RecognitionJournal',
              icon_name: 'icon_home',
          },
          {
              link: 'vehicles_lists',
              name: 'VehiclesLists',
              icon_name: 'icon_list'
          },
          {
              link: 'checkpoints_and_gates',
              name: 'Checkpoints',
              icon_name: 'icon_gate'
          },
          {
              link: 'cameras_and_relays',
              name: 'Devices',
              icon_name: 'icon_camera'
          },
          {
              link: 'network_settings',
              name: 'Network',
              icon_name: 'icon_network'
          },
          {
              link: 'users',
              name: 'Security',
              icon_name: 'icon_safety'
          },
          {
              link: 'system_settings',
              name: 'System',
              icon_name: 'icon_system'
          },
        ],
        socket: {
            is_connected: false,
            message: '',
            reconnect_error: false
        },
        status: '',
        user: {
            username: '',
            role_name: '',
            access_to_tabs: [],
            logged_in: null,
        },
        default_user: {
            username: '',
            role_name: '',
            access_to_tabs: [],
            logged_in: null,
        },
        
        snackbar: {
            alert: false,
            text: '',
            timeout: 3000,
        },
        loading_overlay: {
            is_loading: false,
            loading_timeout: 60000,
            timer: '',
            reload_required: false
        },
    },
    mutations: {
        UPDATE_USER_DATA (state, data) {
            state.user.logged_in = data.logged_in
            state.user.username = data.username
            state.user.role_name = data.role_name
            state.user.access_to_tabs = data.access_to_tabs
        },
        UPDATE_USER_STATUS(state, status) {
          state.user.logged_in = status
        },
        UPDATE_SNACKBAR: (state, snackbar) => {
            state.snackbar.alert = snackbar.alert;
            state.snackbar.text = snackbar.text;
            if (snackbar.timeout) {
             state.snackbar.timeout = snackbar.timeout;
            }
        },
        UPDATE_LOADING_OVERLAY: (state, loading_settings) => {
            if (loading_settings.is_loading === false) clearTimeout(state.loading_overlay.timer)
            if (!loading_settings.reload_required) {
             state.loading_overlay.reload_required = false;
            }
            for (let [param_key, param_value] of Object.entries(loading_settings)) {
                state.loading_overlay[param_key] = param_value
            }
        },
        UPDATE_DATETIME_INFO: (state, params) => {
            state.system_datetime = params.datetime
        },
        UPDATE_RELAYS_CONNECTION_STATE: (state, system_connection_state) => {
          state.system_connection_state.relays_are_connected = system_connection_state.relays_are_connected
        },
        UPDATE_SERVICE_CONNECTION_STATE: (state, system_connection_state) => {
          state.system_connection_state.service_is_connected = system_connection_state.service_is_connected
        },
        UPDATE_SYSTEM_PARAMS: (state, system_params) => {
            for (let [param_key, param_value] of Object.entries(system_params)) {
                state.system_params[param_key] = param_value
            }
        },
        SOCKET_ONOPEN (state, event)  {
            Vue.prototype.$socket = event.currentTarget;
            state.socket.is_connected = true;
            console.log('Websocket connection established');
        },
        // eslint-disable-next-line no-unused-vars
        SOCKET_ONCLOSE (state, event)  {
          state.socket.is_connected = false
        },
        SOCKET_ONERROR (state, event)  {
          console.error(state, event)
        },
        // default handler called for all methods
        SOCKET_ONMESSAGE (state, message)  {
          state.socket.message = message
          EventBus.$emit('ws_on_message', message.data)
        },
        // mutations for reconnect methods
        SOCKET_RECONNECT(state, count) {
          console.info(state, count)
        },
        SOCKET_RECONNECT_ERROR(state) {
          state.socket.reconnectError = true;
        },
    },
    getters : {
      snackbar: (state) => state.snackbar,
      isLoggedIn: (state) => state.user.logged_in,
      loadingOverlay: (state) => state.loading_overlay,
      systemConnectionState: (state) => state.system_connection_state,
      systemParams: (state) => state.system_params,
      systemDatetime: (state) => state.system_datetime,
      timezonesInfo: (state) => {
          return {
            system_timezone: state.current_system_timezone,
            browser_timezone: state.current_browser_timezone,
          }
      },
      charTransc: (state) => state.chars_transcription,
    },
    actions: {
        async setSnackbar({commit}, params) {
            commit('UPDATE_SNACKBAR', Object.assign({}, {alert: true}, params))
        },
        async resetSnackbar({commit}) {
            const setting = {
                alert: false,
                text: '',
                timeout: 3000
            };
            commit('UPDATE_SNACKBAR', setting)
        },
        async changeUserData({commit}, params) {
            commit('UPDATE_USER_DATA', params)
        },
        updateDatetime({commit}, params) {
            commit('UPDATE_DATETIME_INFO', params)
        },
        async isUserLoggedIn({commit}) {
            await axios({url: '/api/users/is_logged_in', data: {}, method: 'POST'})
              .then(resp => {
                if (resp.data.result === 'ok') {
                 let data = resp.data
                  data.user.logged_in = true
                  commit('UPDATE_USER_DATA', data.user)
                } else {
                  commit('UPDATE_USER_STATUS', false)
                }
              })
              .catch(error => {
                commit('UPDATE_USER_STATUS', false)
                console.log(error)
              })
        },
        updateLoadingOverlay({commit}, loading_settings) {
            commit('UPDATE_LOADING_OVERLAY', loading_settings)
        },
        sendSocketMessage(context, message) {
            Vue.prototype.$socket.send(JSON.stringify(message))
        },
        updateRelayConnectionState({commit}, system_connection_state) {
            commit('UPDATE_RELAYS_CONNECTION_STATE', system_connection_state)
        },
        updateServiceConnectionState({commit}, system_connection_state) {
            commit('UPDATE_SERVICE_CONNECTION_STATE', system_connection_state)
        },
        updateSystemParams({commit}, system_params) {
            commit('UPDATE_SYSTEM_PARAMS', system_params)
        }
    },

})